<script lang="ts">
	import FiltersSelected from '$lib/components/filters/FiltersSelected.svelte';
	import FilterProvider from '$lib/components/filters/store.svelte';
	import { m } from '$lib/paraglide/messages.js';
	import { getContext } from 'svelte';

	import Filter from './Filter.svelte';
	import FilterBoolean from './FilterBoolean.svelte';
	import FilterButton from './FilterButton.svelte';
	import FilterColor from './FilterColor.svelte';
	import { filterOrder } from './filterOrder';
	import FilterPriceRange from './FilterPriceRange.svelte';
	import { type Filter as FilterType } from './store.svelte';

	const { filters, productCount }: { filters: FilterType[]; productCount: number } = $props();

	const rank = (f: FilterType) => filterOrder[f.data.name] ?? 98; // 98 = default rank for unknown filters, with price at 99 (last position)

	const sortedFilters = $derived([...filters].sort((a, b) => rank(a) - rank(b)));

	let isDrawerOpen = $state(false);

	// Même effect que MobileNavigation
	// @TODO? -> Faire une fonction / un composant commun(e) ?
	let oldDocumentOverflow = '';
	$effect(() => {
		if (isDrawerOpen) {
			oldDocumentOverflow = document.documentElement.style.overflow;
			document.documentElement.style.overflow = 'hidden';
		}
		return () => {
			if (isDrawerOpen) document.documentElement.style.overflow = oldDocumentOverflow;
		};
	});

	const filterProvider = getContext<FilterProvider>('filter');
</script>

<FilterButton
	onclick={() => (isDrawerOpen = !isDrawerOpen)}
	class="flex h-full items-center gap-2 xl:hidden"
>
	{@const selectedCount = filterProvider.getSelectedCount()}
	<span class="icon-[mdi--filter] h-5 w-5"></span>
	<span class="font-medium"
		>{m.filters()}
		{#if selectedCount > 0}
			({selectedCount})
		{/if}
	</span>
</FilterButton>

<div
	class={[
		'fixed right-0 bottom-0 left-0 z-15 flex w-full flex-col overflow-y-scroll overscroll-none bg-white px-4 transition duration-300',
		'top-[var(--header-height)] xl:top-[var(--header-total-height)] xl:h-[calc(100dvh-var(--header-total-height)-var(--breadcrumbs-height))]',
		'xl:sticky xl:z-auto xl:self-start xl:px-0 xl:pr-2',
		isDrawerOpen ? 'translate-y-0' : 'translate-y-full opacity-0 xl:translate-y-0 xl:opacity-100',
	]}
>
	<div class="flex grow flex-col gap-2 py-2">
		{#each sortedFilters as filter (filter.data.name)}
			{#if filter.type === 'terms' && filter.data.name === 'in_stock'}
				<FilterBoolean filter={filter.data} />
			{:else if filter.type === 'terms' && filter.data.name === 'main_color_code'}
				<FilterColor filter={filter.data} />
			{:else if filter.type === 'range' && filter.data.name === 'best_price'}
				<FilterPriceRange filter={filter.data} />
			{:else if filter.type === 'terms'}
				<Filter filter={filter.data} />
			{/if}
		{/each}
	</div>

	<div class="sticky right-0 bottom-0 z-15 flex flex-col gap-2 border-t bg-white p-2 xl:hidden">
		<FiltersSelected />
		<button
			class="flex w-full cursor-pointer items-center justify-center gap-2 rounded bg-neutral-800 p-4 text-white xl:hidden"
			onclick={() => (isDrawerOpen = !isDrawerOpen)}
			aria-label="remove filter"
		>
			<span class="icon-[mdi--check]"></span>
			<span>{m['see_products_with_filter']({ count: Number(productCount) })}</span>
		</button>
	</div>
</div>
